import { Home, KeyRound, Building2, Wind, Sofa, Droplets, HardHat, BedDouble } from "lucide-react";

const services = [
  { icon: Home, title: "Residential Cleaning", desc: "Regular house cleaning and deep cleans." },
  { icon: KeyRound, title: "End of Lease Cleaning", desc: "Bond-back focused cleaning services." },
  { icon: Building2, title: "Office Cleaning", desc: "Reliable commercial cleaning." },
  { icon: Wind, title: "Window Cleaning", desc: "Crystal clear internal and external windows." },
  { icon: Sofa, title: "Carpet Cleaning", desc: "Fresh, sanitised carpets." },
  { icon: Droplets, title: "Pressure Washing", desc: "Driveways, pathways and exterior surfaces." },
  { icon: HardHat, title: "Builders Cleans", desc: "Post-construction cleaning services." },
  { icon: BedDouble, title: "Airbnb Cleaning", desc: "Fast guest turnover cleaning." },
];

const ServicesSection = () => (
  <section id="services" className="bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-[#111111] text-center mb-4">
        Our Cleaning Services
      </h2>
      <p className="text-center text-[#111111]/70 mb-14 max-w-lg mx-auto">
        Professional cleaning solutions for every property.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map((s) => (
          <div
            key={s.title}
            className="bg-white border border-[#111111]/8 rounded-xl p-7 hover:shadow-[0_8px_30px_rgba(0,102,255,0.12)] hover:-translate-y-1 hover:border-[#0066FF]/30 transition-all duration-300"
          >
            <div className="w-12 h-12 bg-[#FFD400] rounded-full flex items-center justify-center mb-5">
              <s.icon className="w-6 h-6 text-[#111111]" />
            </div>
            <h3 className="text-lg font-bold text-[#111111] mb-2">{s.title}</h3>
            <p className="text-[#111111]/70 leading-relaxed text-sm">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
